import axios from "axios";
import accessPermissions from "../../models/permisosDeAcceso/accessPermissions";
import segments from "../../models/permisosDeAcceso/segments";
import elements from "../../models/permisosDeAcceso/elements";
import dfis from "../../models/permisosDeAcceso/dfis";
import employees from "../../models/permisosDeAcceso/employees";
import groups from "../../models/permisosDeAcceso/groups";
import typesHolidays from "../../models/permisosDeAcceso/typesHolidays";
import dfisAll from "../../models/permisosDeAcceso/dfisAll";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  // ===============================================Permisos==========================================================
  getAccessPermissions() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/dcapermisos`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return accessPermissions.fromJson(item);
        });
      });
  }
  getSegmentsPermissionId(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/dcasegmentos/${id}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return segments.fromJson(item);
        });
      });
  }
  newAllPermission(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.nombre,
      gruposFeriados: data.grupoFeriados,
      empleados: data.listaEmpleados,
    };

    return axios.post(`${url}/dcapermisos/all`, payload, { headers });
  }

  newAccessPermissions(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.name,
      reqPin: data.reqPin === "true",
      reqCacheo: data.reqCacheo === "true",
      reqPassBack: data.reqPassBack === "true",
      visita: data.visit === "true",
      activo: data.active === "true",
    };

    if (data.reqCacheo === "true") {
      payload.porcenCacheo = Number(data.porcenCacheo);
    }

    return axios.post(`${url}/dcapermisos`, payload, { headers });
  }

  editAccessPermissions(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const id = data.id;

    const payload = {
      nombre: data.name,
      reqPin: data.reqPin === "true",
      reqCacheo: data.reqCacheo === "true",
      reqPassBack: data.reqPassBack === "true",
      visita: data.visit === "true",
      activo: data.active === "true",
    };

    if (data.reqCacheo === "true") {
      payload.porcenCacheo = Number(data.porcenCacheo);
    }

    return axios
      .patch(`${url}/dcapermisos/${id}`, payload, { headers })
      .then(() => {});
  }

  deleteAccessPermissions(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/dcapermisos/${id}`, { headers });
  }

  // ===============================================Segmentos==========================================================
  getSegments(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const id = data;
    return axios
      .get(`${url}/dcasegmentos/${id}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return segments.fromJson(item);
        });
      });
  }

  newSegment(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      permisoId: data.permissionId,
      numSecuencia: Number(data.sequence),
      nombre: data.name,
      dias: Number(data.days),
      desplJornada: data.desplJor,
      tipoJornada: Number(data.jor),
      reqPin: Number(data.reqPin),
      reqCacheo: Number(data.reqCacheo),
      reqPassBack: Number(data.reqPassBack),
      porcenCacheo: Number(data.porcenCacheo),
    };
    if (Number(data.reqCacheo) === 1) {
      payload.porcenCacheo = Number(data.porcenCacheo);
    }

    return axios.post(`${url}/dcasegmentos`, payload, { headers });
  }

  editSegment(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const id = data.segmId;

    const payload = {
      numSecuencia: Number(data.sequence),
      nombre: data.name,
      dias: Number(data.days),
      desplJornada: data.desplJor,
      tipoJornada: Number(data.jor),
      reqPin: Number(data.reqPin),
      reqCacheo: Number(data.reqCacheo),
      reqPassBack: Number(data.reqPassBack),
    };
    if (Number(data.reqCacheo) === 1) {
      payload.porcenCacheo = Number(data.porcenCacheo);
    } else {
      payload.porcenCacheo = 0;
    }

    return axios.patch(`${url}/dcasegmentos/${id}`, payload, { headers });
  }

  deleteSegments(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(`${url}/dcasegmentos/${id}`, { headers });
  }

  getElements(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const id = data;
    return axios
      .get(`${url}/dcaelementos/${id}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return elements.fromJson(item);
        });
      });
  }

  newElementToSegment(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      permisoId: data.permisoId,
      segmId: data.segmId,
      nombre: data.nombre,
      desde: data.desde,
      hasta: data.hasta,
      aplNoFeriados: data.aplNoFeriados,
      aplFeriados: data.aplFeriados,
      reqPin: data.reqPin,
      reqCacheo: data.reqCacheo,
      reqPassBack: data.reqPassBack,
      porcenCacheo: isNaN(data.porcenCacheo) ? 0 : data.porcenCacheo,
      dfis: data.dfis,
    };

    return axios.post(`${url}/dcaelementos`, payload, { headers });
  }

  editElement(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const id = data.id;
    let payload = {
      nombre: data.nombre,
      desde: data.desde,
      hasta: data.hasta,
      aplNoFeriados: data.aplNoFeriados,
      aplFeriados: data.aplFeriados,
      reqPin: data.reqPin,
      reqCacheo: data.reqCacheo,
      reqPassBack: data.reqPassBack,
      porcenCacheo: isNaN(data.porcenCacheo) ? 0 : data.porcenCacheo,
      dfis: data.dfis,
    };

    return axios
      .patch(`${url}/dcaelementos/${id}`, payload, { headers })
      .then(() => {});
  }
  deleteElement(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(`${url}/dcaelementos/${id}`, { headers });
  }

  getAllDfis() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/dcadfis`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return dfisAll.fromJson(item);
        });
      });
  }

  getDFis(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/dcaelemdfis/${id}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return dfis.fromJson(item);
        });
      });
  }
  // ===============================================Empleados==================================================================
  getEmployees(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/dcapermisoempleados/${id}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return employees.fromJson(item);
        });
      });
  }

  newEmployeeToPermission(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      empId: data.empId,
      permisoId: data.permisoId,
      fecDesde: data.fecDesde,
      fecHasta: data.fecHasta,
      segmId: data.segmId,
      segmDespl: data.segmDespl,
    };

    return axios.post(`${url}/dcapermisoempleados`, payload, { headers });
  }

  editEmployeeToPermission(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const id = data.id;

    const payload = {
      empId: data.empId,
      permisoId: data.permisoId,
      fecDesde: data.fecDesde,
      fecHasta: data.fecHasta,
      segmId: data.segmId,
      segmDespl: data.segmDespl,
    };

    return axios
      .patch(
        `${url}/dcapermisoempleados/${data.empid}&${data.permisoid}&${data.fecdesde}`,
        payload,
        { headers }
      )
      .then(() => {});
  }

  deleteEmployeeToPermission(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/dcapermisoempleados/${data.empId}&${data.permisoId}&${data.fecDesde}`,
      { headers }
    );
  }
  // ===============================================Grupos=====================================================================
  getGroups(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/dcapermisogrupos/${id}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return groups.fromJson(item);
        });
      });
  }
  newGroupToPermission(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      grupoId: data.id,
      permisoId: data.permisoId,
      fecDesde: data.fecDesde,
      fecHasta: data.fecHasta,
      segmId: data.segmId,
      segmDespl: data.segmDespl,
    };

    return axios.post(`${url}/dcapermisogrupos`, payload, { headers });
  }

  editGroupToPermission(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const id = data.id;

    const payload = {
      grupoId: data.id,
      permisoId: data.permisoId,
      fecDesde: data.fecDesde,
      fecHasta: data.fecHasta,
      segmId: data.segmId,
      segmDespl: data.segmDespl,
    };

    return axios
      .patch(
        `${url}/dcapermisogrupos/${data.id}&${data.permisoId}&${data.fecDesde}`,
        payload,
        { headers }
      )
      .then(() => {});
  }

  deleteGroupToPermission(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/dcapermisogrupos/${data.grupoId}&${data.permisoId}&${data.fecDesde}`,
      { headers }
    );
  }
  // ===============================================Tipos de feriados==========================================================
  getTypesHolidays(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/dcapermisotiposfer/${id}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return typesHolidays.fromJson(item);
        });
      });
  }
  newTypeHolidayToPermission(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      permisoId: data.permisoId,
      tipoFerId: data.id,
    };

    return axios.post(`${url}/dcapermisos`, payload, { headers });
  }

  deleteTypeHolidayToPermission(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/dcapermisotiposfer/${data.permisoId}&${data.id}`,
      { headers }
    );
  }
}
export default service;
